var RepositoryAPI = require("../../../common/api/repository");
var VideoUrlParser = require('js-video-url-parser');
module.exports = function ($scope, item) {

  var getThumbnailUrl = function(parsedUrl) {
    var id = parsedUrl.id;
    return "https://img.youtube.com/vi/" + id + "/hqdefault.jpg";
  }

  $scope.item = item;
  $scope.unparsedUrl = item.videoUrl ? item.videoUrl.toString() : null; //We're cloning the string here CH

  var parsedUrl;

  $scope.urlUpdated = function(unparsedUrl) {
    parsedUrl = VideoUrlParser.parse(unparsedUrl);
    if (parsedUrl && parsedUrl.provider === 'youtube') {
      $scope.item.url = getThumbnailUrl(parsedUrl);
      $scope.item.isVideo = true;
      $scope.item.videoUrl = VideoUrlParser.create({videoInfo: parsedUrl});
    } else {
      $scope.item.url = "//:0";
      $scope.item.isVideo = false;
      delete $scope.item.videoUrl;
    }
  }

  $scope.submit = function() {
    $scope.closeThisDialog({ action: "submit", item: $scope.item });
  };

  $scope.cancel = function() {
    $scope.closeThisDialog({ action: "cancel" });
  };
};
